import React from 'react';

import currencyHelper from '../../../../helpers/currencyHelper';
import CurrencyDisplay from '../../CurrencyDisplay';

interface CurrencyFormatterProps {
  value: number;
  truncate?: boolean;
  fixed?: number;
  additionalData?: any;
  alwaysShowDecimals?: boolean;
  deEmphasizeDecimals?: boolean;
}

const CurrencyFormatter = ({
  value,
  truncate,
  additionalData,
  fixed = 2,
  alwaysShowDecimals = false,
  deEmphasizeDecimals = false
}: CurrencyFormatterProps) => {
  if (typeof value !== "number") {
    return <div className="currency-formatter"></div>;
  }

  let number = Math.round(value * 100) / 100;
  if (truncate) {
    number = Math.floor(number);
  }

  const formattedValue = currencyHelper.formatCurrency(number, additionalData?.currency, {
    alwaysShowDecimals
  });

  return (
    <div className="currency-formatter">
      <CurrencyDisplay 
        amount={formattedValue}
        currency={additionalData?.currency}
        showCurrency={!!additionalData?.currency}
        deEmphasizeDecimals={deEmphasizeDecimals}
      />
    </div>
  );
};

export default CurrencyFormatter;
